import { Tab, Tabs } from "@mui/material";
import type { FC } from "react";
import { useGoalsRightOptional } from "web_myplann/Api/Rights/RightsProvider";

type Props = {
	value: number;
	onChange: (event: React.SyntheticEvent, newValue: number) => void;
	tabs: { id: string; label: string }[];
};

const PILOT_TAB_HEIGHT = 32;

export const MyPlannTabsRedesign: FC<Props> = ({ value, onChange, tabs }) => {
	const hasGoalsRight = useGoalsRightOptional();

	return (
		<Tabs
			redesigned
			value={value}
			onChange={onChange}
			variant="fullWidth"
			sx={hasGoalsRight ? { "& .MuiTabs-flexContainer": { gap: 0 } } : {}}
		>
			{tabs.map((tab) => (
				<Tab
					redesigned
					key={tab.id}
					label={tab.label}
					disableRipple
					sx={
						hasGoalsRight
							? {
									height: PILOT_TAB_HEIGHT,
									border: "none",
									"&.Mui-selected": { boxShadow: "none" },
								}
							: {}
					}
				/>
			))}
		</Tabs>
	);
};
